// src/sections/Distribuzione.jsx
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Distribuzione = ({ contenuti }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const contenutiArray = Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti);

  return (
    <>
      {contenutiArray.map((content, idx) => {
        const {
          titolo_1,
          titolo_2,
          sottotitolo_it,
          descrizione_it,
          immagini_aggiuntive = [],
        } = content;

        const imagePaths = immagini_aggiuntive.map(img => img.immagine_path);

        return (
          <div key={idx} className="container-fluid py-4">
            {/* testo + titolo */}
            <div className="container mb-3">
              <div className="row">
                <div className="col-12 col-md-6 mb-3 mb-md-0">
                  {sottotitolo_it && (
                    <p className="mini-title text-secondary">{sottotitolo_it}</p>
                  )}
                  <span className="d-flex flex-wrap align-items-baseline title-section">
                    <h2
                      className={`black-text me-2 ${
                        isMobile ? 'd-block' : 'd-inline'
                      }`}
                    >
                      {titolo_1}
                    </h2>
                    <h2
                      className={`green-text ${
                        isMobile ? 'd-block' : 'd-inline'
                      }`}
                    >
                      {titolo_2}
                    </h2>
                  </span>
                </div>
                <div className="col-12 col-md-6">
                  <p
                    className="custom-text"
                    dangerouslySetInnerHTML={{ __html: descrizione_it }}
                  />
                </div>
              </div>
            </div>

            {/* gallery 2+1 + 2+1 */}
            <div className="container">
              <div className="row gx-2 gy-2 align-items-stretch">
                {/* prima metà */}
                <div className="col-12 col-md-6">
                  <div className="row gx-2 gy-2 h-100 align-items-stretch">
                    {/* due in colonna */}
                    <div className="col-6 d-flex flex-column gap-2">
                      {imagePaths.slice(0, 2).map((src, i) => (
                        <img
                          key={i}
                          src={src}
                          alt={`img-${i + 1}`}
                          className="img-fluid flex-fill w-100"
                          style={{ objectFit: 'cover' }}
                        />
                      ))}
                    </div>
                    {/* una affiancata */}
                    <div className="col-6">
                      {imagePaths[2] && (
                        <img
                          src={imagePaths[2]}
                          alt="img-3"
                          className="img-fluid w-100 h-100"
                          style={{ objectFit: 'cover' }}
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* seconda metà */}
                <div className="col-12 col-md-6">
                  <div className="row gx-2 gy-2 h-100 align-items-stretch">
                    <div className="col-6 d-flex flex-column gap-2">
                      {imagePaths.slice(3, 5).map((src, i) => (
                        <img
                          key={i}
                          src={src}
                          alt={`img-${i + 4}`}
                          className="img-fluid flex-fill w-100"
                          style={{ objectFit: 'cover' }}
                        />
                      ))}
                    </div>
                    <div className="col-6">
                      {imagePaths[5] && (
                        <img
                          src={imagePaths[5]}
                          alt="img-6"
                          className="img-fluid w-100 h-100"
                          style={{ objectFit: 'cover' }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Distribuzione;
